import { FC, MouseEvent } from "react";

import PauseIcon from "@svg/player/Pause";
import PlayIcon from "@svg/player/Play";
import Tooltip from "@shared/components/tooltip/Tooltip";
import { TOOLTIP_THEME } from "@shared/components/tooltip/constants";

interface Props {
  isMobile: boolean;
  isPlaying: boolean;
  togglePlayByClickHandler: (
    e: MouseEvent<HTMLElement | SVGSVGElement>
  ) => void;
  controlsIconProps: any;
}

const VideoPlayerPlayButtonInMobile: FC<Props> = ({
  isMobile,
  isPlaying,
  togglePlayByClickHandler,
  controlsIconProps,
}) => {
  return (
    <Tooltip
      theme={TOOLTIP_THEME.LIGHT}
      showArrow={false}
      disabled={isMobile}
      message={isPlaying ? "توقف" : "پخش"}
    >
      <button onClick={togglePlayByClickHandler}>
        {isPlaying ? (
          <PauseIcon
            {...controlsIconProps}
            className="nply-play-pause-mobile-icon"
          />
        ) : (
          <PlayIcon
            {...controlsIconProps}
            className="nply-play-pause-mobile-icon"
          />
        )}
      </button>
    </Tooltip>
  );
};

export default VideoPlayerPlayButtonInMobile;
